module.exports = __webpack_public_path__ + "static/img/hexinneirong.8a8f033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/yunwei/hexinneirong.jpg
// module id = kgdC
// module chunks = 6